/* Модуль платформы, безопасного хранилища и сессии */

// Неблокирующий fallback мок Telegram WebApp SDK для внешних браузеров
// и защиты интерфейса от сетевых сбоев/блокировок telegram.org
if (!window.Telegram) {
  window.Telegram = {};
}
if (!window.Telegram.WebApp) {
  window.Telegram.WebApp = {
    isMock: true,
    initData: '',
    initDataUnsafe: {},
    colorScheme: 'light',
    themeParams: {},
    isExpanded: true,
    viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 800,
    viewportStableHeight: typeof window !== 'undefined' ? window.innerHeight : 800,
    ready: function() {},
    expand: function() {},
    close: function() {},
    enableClosingConfirmation: function() {},
    disableVerticalSwipes: function() {},
    setHeaderColor: function() {},
    setBackgroundColor: function() {},
    onEvent: function() {},
    offEvent: function() {},
    sendData: function() {},
    openLink: function(url) { if (url) window.open(url, '_blank'); },
    openTelegramLink: function(url) { if (url) window.open(url, '_blank'); },
    BackButton: {
      isVisible: false,
      show: function() { this.isVisible = true; },
      hide: function() { this.isVisible = false; },
      onClick: function() {},
      offClick: function() {}
    },
    MainButton: {
      text: '',
      color: '',
      textColor: '',
      isVisible: false,
      isActive: true,
      show: function() { this.isVisible = true; },
      hide: function() { this.isVisible = false; },
      enable: function() { this.isActive = true; },
      disable: function() { this.isActive = false; },
      onClick: function() {},
      offClick: function() {}
    },
    HapticFeedback: {
      impactOccurred: function() {},
      notificationOccurred: function() {},
      selectionChanged: function() {}
    }
  };
}

// Обработчик асинхронного подключения официального SDK telegram.org
function onTelegramSDKReady() {
  const tg = window.Telegram?.WebApp;
  if (tg && !tg.isMock) {
    try {
      if (typeof tg.ready === 'function') tg.ready();
      if (typeof tg.expand === 'function') tg.expand();
      if (typeof tg.disableVerticalSwipes === 'function') tg.disableVerticalSwipes();
      if (typeof tg.enableClosingConfirmation === 'function') tg.enableClosingConfirmation();
      if (typeof tg.setHeaderColor === 'function') tg.setHeaderColor('#F7F4EE');
      if (typeof tg.setBackgroundColor === 'function') tg.setBackgroundColor('#F7F4EE');
    } catch (e) {}

    if (typeof initTelegramBackButton === 'function') {
      try { initTelegramBackButton(); } catch (e) {}
    }
    if (typeof syncProfileWithServer === 'function') {
      try { syncProfileWithServer(); } catch (e) {}
    }
  }
}
window.__onTelegramLoaded = onTelegramSDKReady;

// Поддержка быстрого сброса сессии для тестирования (?reset=1)
try {
  if (typeof window !== 'undefined' && window.location && window.location.search && window.location.search.includes('reset=1')) {
    try { if (window.localStorage) window.localStorage.clear(); } catch (e) {}
    try { if (window.sessionStorage) window.sessionStorage.clear(); } catch (e) {}
    try {
      (document.cookie || '').split(';').forEach(c => {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
      });
    } catch (e) {}
    window.location.replace(window.location.pathname);
  }
} catch (e) {}

const STORAGE_KEY = 'meta_user_profile';
const REGISTERED_FLAG = 'meta_user_registered';
const STORAGE_REF_COUNT = 'meta_referral_count';
const BOT_USERNAME = 'meta_institut_bot';
const SHARE_TEXT = '';

function setSessionCookie(name, val, days = 365) {
  try {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(val)}; expires=${expires}; path=/; SameSite=Lax`;
  } catch (e) {}
}

function getSessionCookie(name) {
  try {
    const prefix = encodeURIComponent(name) + '=';
    const parts = (document.cookie || '').split(';');
    for (let i = 0; i < parts.length; i++) {
      let p = parts[i].trim();
      if (p.indexOf(prefix) === 0) {
        return decodeURIComponent(p.substring(prefix.length));
      }
    }
  } catch (e) {}
  return null;
}
window.setSessionCookie = setSessionCookie;
window.getSessionCookie = getSessionCookie;

// Безопасное хранилище (защита от SecurityError в Safari ITP / cross-origin iframe)
const memoryStore = {};
const safeStorage = {
  getItem: function(key) {
    try {
      const val = window.localStorage ? window.localStorage.getItem(key) : null;
      if (val !== null) return val;
      if (memoryStore[key] !== undefined) return memoryStore[key];
      if (key === REGISTERED_FLAG || key === 'meta_registered' || key === 'meta_user_id') {
        const cVal = getSessionCookie(key);
        if (cVal !== null) return cVal;
      }
      return null;
    } catch (e) {
      if (memoryStore[key] !== undefined) return memoryStore[key];
      if (key === REGISTERED_FLAG || key === 'meta_registered' || key === 'meta_user_id') {
        return getSessionCookie(key);
      }
      return null;
    }
  },
  setItem: function(key, val) {
    const sVal = String(val);
    memoryStore[key] = sVal;
    try {
      if (window.localStorage) window.localStorage.setItem(key, sVal);
    } catch (e) {}
    if (key === REGISTERED_FLAG || key === 'meta_registered' || key === 'meta_user_id') {
      setSessionCookie(key, sVal);
    }
  },
  removeItem: function(key) {
    delete memoryStore[key];
    try {
      if (window.localStorage) window.localStorage.removeItem(key);
    } catch (e) {}
    if (key === REGISTERED_FLAG || key === 'meta_registered' || key === 'meta_user_id') {
      setSessionCookie(key, '', -1);
    }
  }
};
const localStorage = safeStorage;

window.META_BOT_USERNAME = window.META_BOT_USERNAME || localStorage.getItem('meta_bot_username') || 'meta_institut_bot';
window.META_BOT_APP_URL = window.META_BOT_APP_URL || 'https://t.me/meta_institut_bot/meta';

// Яндекс.Метрика: ID счетчика и функции фиксации целей
const _savedYm = localStorage.getItem('meta_ym_counter_id');
window.YM_COUNTER_ID = (_savedYm && _savedYm !== '00000000') ? _savedYm : '113778837';

function trackGoal(goalName, params = {}) {
  try {
    const counterId = window.YM_COUNTER_ID || localStorage.getItem('meta_ym_counter_id');
    if (typeof window.ym === 'function' && counterId && counterId !== '00000000') {
      window.ym(Number(counterId), 'reachGoal', goalName, params);
      console.log(`[Metrika] Цель зафиксирована: ${goalName}`, params);
    }
  } catch (e) {
    console.warn('[Metrika] Ошибка отправки цели:', e);
  }
}
window.trackGoal = trackGoal;

function initYandexMetrika(counterId) {
  if (!counterId || counterId === '00000000') return;
  window.YM_COUNTER_ID = String(counterId);
  try {
    localStorage.setItem('meta_ym_counter_id', String(counterId));
    if (typeof window.ym !== 'function') {
      (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a);
      })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      window.ym(Number(counterId), "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
      });
    }
    console.log(`[Metrika] Счетчик ${counterId} успешно подключен.`);
  } catch (e) {
    console.warn('[Metrika] Ошибка инициализации счетчика:', e);
  }
}
window.initYandexMetrika = initYandexMetrika;

if (window.YM_COUNTER_ID && window.YM_COUNTER_ID !== '00000000') {
  initYandexMetrika(window.YM_COUNTER_ID);
}

// Безопасное экранирование спецсимволов HTML
function escapeHTML(str) {
  if (str === null || str === undefined) return '';
  return String(str).replace(/[&<>'"]/g, 
    tag => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[tag] || tag)
  );
}

// Тактильный отклик Telegram WebApp
function triggerHaptic(type = 'light') {
  const tg = window.Telegram?.WebApp;
  if (tg?.HapticFeedback) {
    try {
      if (type === 'success' || type === 'error' || type === 'warning') {
        tg.HapticFeedback.notificationOccurred(type);
      } else {
        tg.HapticFeedback.impactOccurred(type);
      }
    } catch (e) {}
  }
}

// Надежное открытие Telegram-бота с автоматическим обходом блокировок t.me (ERR_CONNECTION_CLOSED)
// На мобильных устройствах использует системный протокол tg://resolve, напрямую запускающий приложение Telegram.
function openTelegramBot(param = '', options = {}) {
  const botUser = window.META_BOT_USERNAME || localStorage.getItem('meta_bot_username') || 'meta_institut_bot';
  const cleanParam = String(param || '').trim();
  
  const tgAppUrl = cleanParam 
    ? `tg://resolve?domain=${encodeURIComponent(botUser)}&start=${encodeURIComponent(cleanParam)}`
    : `tg://resolve?domain=${encodeURIComponent(botUser)}`;
    
  const tgWebUrl = cleanParam
    ? `https://t.me/${encodeURIComponent(botUser)}?start=${encodeURIComponent(cleanParam)}`
    : `https://t.me/${encodeURIComponent(botUser)}`;

  // 1. Если запущен внутри Telegram WebApp
  if (window.Telegram?.WebApp?.openTelegramLink) {
    try {
      window.Telegram.WebApp.openTelegramLink(tgWebUrl);
      return;
    } catch (e) {}
  }

  // 2. Определение мобильного устройства
  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  if (isMobile) {
    // Системный вызов через протокол tg:// исключает HTTP-обращение к t.me
    window.location.href = tgAppUrl;

    const startTime = Date.now();
    setTimeout(() => {
      if (!document.hidden && (Date.now() - startTime) < 3000) {
        window.location.href = tgWebUrl;
      }
    }, 1800);
  } else {
    // На десктопе пробуем Telegram Desktop
    window.location.href = tgAppUrl;
    setTimeout(() => {
      if (!document.hidden) {
        window.open(tgWebUrl, '_blank', 'noopener,noreferrer');
      }
    }, 1000);
  }
}
window.openTelegramBot = openTelegramBot;

// Надежное открытие Telegram-канала или чата по ссылке инвайта
function openTelegramChannelOrChat(url) {
  if (!url) return;
  const rawUrl = String(url).trim();
  let tgScheme = rawUrl;
  const joinMatch = rawUrl.match(/t\.me\/(?:\+|joinchat\/)([A-Za-z0-9_-]+)/);
  if (joinMatch) {
    tgScheme = `tg://join?invite=${joinMatch[1]}`;
  } else {
    const userMatch = rawUrl.match(/t\.me\/([A-Za-z0-9_]+)/);
    if (userMatch) {
      tgScheme = `tg://resolve?domain=${userMatch[1]}`;
    }
  }

  if (window.Telegram?.WebApp?.openTelegramLink) {
    try {
      window.Telegram.WebApp.openTelegramLink(rawUrl);
      return;
    } catch (e) {}
  }

  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  if (isMobile) {
    window.location.href = tgScheme;
    const startTime = Date.now();
    setTimeout(() => {
      if (!document.hidden && (Date.now() - startTime) < 3000) {
        window.location.href = rawUrl;
      }
    }, 1800);
  } else {
    window.location.href = tgScheme;
    setTimeout(() => {
      if (!document.hidden) {
        window.open(rawUrl, '_blank', 'noopener,noreferrer');
      }
    }, 1000);
  }
}
window.openTelegramChannelOrChat = openTelegramChannelOrChat;

// Каноническое описание дней марафона
const MARATHON_DAYS_INFO = {
  1: { title: 'День 1: 4 стихии и тело: почему нет сил и где взять энергию', subtitle: '4 стихии и тело: почему нет сил и где взять энергию', date: 'Урок доступен', icon: '🟢' },
  2: { title: 'День 2: Семья и партнер: почему он закрылся и как вернуть тепло', subtitle: 'Семья и партнер: почему он закрылся и как вернуть тепло', date: 'Доступен по расписанию', icon: '🔒' },
  3: { title: 'День 3: Деньги, долги и самооценка: где заблокирован ваш доход', subtitle: 'Деньги, долги и самооценка: где заблокирован ваш доход', date: 'Доступен по расписанию', icon: '🔒' },
  4: { title: 'День 4: Большой финал: сборка навигатора жизни и живые разборы', subtitle: 'Большой финал: сборка навигатора жизни и живые разборы', date: 'Урок доступен', icon: '🔥' },
  'all': { title: 'Все 4 дня интенсива', subtitle: 'Полный доступ ко всей программе', date: 'Бессрочный доступ', icon: '🌟' }
};

const DAY_SCHEDULE_BADGES = {
  1: '✓ Доступно • Урок 1',
  2: '✓ Доступно • Урок 2',
  3: '✓ Доступно • Урок 3',
  4: '✓ Доступно • Урок 4'
};


  // Платформенная детекция (100% Telegram Mini App)
  function isVKPlatform() {
    return false;
  }

  function getSafeMoscowDateString() {
    try {
      return new Date().toISOString();
    } catch (e) {
      return new Date().toISOString();
    }
  }

  let inMemoryUser = null;

  // Получить данные текущего пользователя из хранилища, Telegram или оперативной памяти
  function getUser() {
    try {
      const data = localStorage.getItem(STORAGE_KEY) || localStorage.getItem('meta_user');
      if (data) {
        inMemoryUser = JSON.parse(data);
        return inMemoryUser;
      }
      const cookieUserId = getSessionCookie('meta_user_id');
      if (cookieUserId) {
        inMemoryUser = inMemoryUser || { id: cookieUserId, registered: true };
        return inMemoryUser;
      }

      // Telegram WebApp профиль (пользователь открыл приложение внутри Telegram)
      const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
      if (tgUser && (tgUser.id || tgUser.username)) {
        inMemoryUser = inMemoryUser || {
          id: tgUser.id,
          telegram_id: tgUser.id,
          telegramId: tgUser.id,
          username: tgUser.username || '',
          name: [tgUser.first_name, tgUser.last_name].filter(Boolean).join(' ') || tgUser.username || 'Участник',
          registered: true
        };
        return inMemoryUser;
      }

      // URL параметры идентификации (до завершения сетевой синхронизации)
      const p = new URLSearchParams(window.location.search);
      const hp = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
      const qUid = p.get('user_id') || hp.get('user_id');
      const qTid = p.get('telegram_id') || hp.get('telegram_id');
      if (qUid || qTid) {
        inMemoryUser = inMemoryUser || {
          id: qUid || qTid,
          telegram_id: qTid ? (Number(qTid) || qTid) : undefined,
          telegramId: qTid ? (Number(qTid) || qTid) : undefined,
          registered: true
        };
        return inMemoryUser;
      }

      inMemoryUser = null;
      return null;
    } catch (e) {}
    return inMemoryUser;
  }

  function isRegistered() {
    try {
      // 1. Прямой флаг регистрации в локальном хранилище или cookie
      const isFlag = localStorage.getItem(REGISTERED_FLAG) === 'true' || 
                     localStorage.getItem('meta_registered') === 'true' ||
                     getSessionCookie('meta_user_registered') === 'true' ||
                     Boolean(getSessionCookie('meta_user_id'));
      if (isFlag) {
        const u = getUser();
        if (u && (u.id || u.phone || u.registered)) return true;
      }

      // 2. Внутри Telegram WebApp при наличии данных пользователя
      const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
      if (tgUser && (tgUser.id || tgUser.username)) {
        return true;
      }

      // 3. Параметры авторизации в URL
      const p = new URLSearchParams(window.location.search);
      const hp = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
      if (p.get('telegram_id') || p.get('user_id') || hp.get('telegram_id') || hp.get('user_id')) {
        return true;
      }

      // 4. Профиль в оперативной памяти
      const u = getUser();
      return Boolean(u && (u.id || u.phone || u.registered));
    } catch (e) {}
    return false;
  }

  window.getUser = getUser;
  window.isRegistered = isRegistered;

  // Запрос разрешения писать пользователю (Telegram bot write access, строго внутри Telegram)
  function requestBotWriteAccess() {
    if (isRegistered()) {
      return Promise.resolve(false);
    }

    // Telegram: запрос разрешения писать пользователю от бота (только внутри Telegram WebApp)
    const tg = window.Telegram?.WebApp;
    const isInsideTelegram = !!(tg && tg.initData && tg.initData.length > 0);
    if (!isInsideTelegram || typeof tg.requestWriteAccess !== 'function') {
      return Promise.resolve(false);
    }
    return new Promise((resolve) => {
      let resolved = false;
      const timer = setTimeout(() => {
        if (!resolved) {
          resolved = true;
          resolve(false);
        }
      }, 2500);

      try {
        tg.requestWriteAccess((allowed) => {
          if (!resolved) {
            resolved = true;
            clearTimeout(timer);
            if (allowed) {
              console.log('[MetaOnboarding] Пользователь разрешил боту писать сообщения');
            }
            resolve(!!allowed);
          }
        });
      } catch (err) {
        if (!resolved) {
          resolved = true;
          clearTimeout(timer);
          console.warn('[MetaOnboarding] requestWriteAccess failed:', err);
          resolve(false);
        }
      }
    });
  }

  const STORAGE_UNLOCKED_DAYS = 'meta_unlocked_days';
  const STORAGE_INVITED_FRIENDS = 'meta_invited_friends';

  // Расчет времени открытия следующего урока по двухволновому расписанию (МСК = UTC+3)
  function getNextDripSlotTimestamp(completedAt) {
    if (!completedAt) return null;
    const dt = new Date(completedAt);
    if (isNaN(dt.getTime())) return null;

    // Смещение MSK = UTC+3 (+3 часа)
    const mskTimeMs = dt.getTime() + (3 * 3600 * 1000);
    const mskDate = new Date(mskTimeMs);

    const year = mskDate.getUTCFullYear();
    const month = mskDate.getUTCMonth();
    const day = mskDate.getUTCDate();
    const hours = mskDate.getUTCHours();

    if (hours < 5) {
      // Ночью до 05:00 МСК -> сегодня в 10:00 МСК (07:00 UTC)
      return Date.UTC(year, month, day, 10 - 3, 0, 0);
    } else if (hours < 14) {
      // Утром и днем с 05:00 до 14:00 МСК -> сегодня в 19:00 МСК (16:00 UTC)
      return Date.UTC(year, month, day, 19 - 3, 0, 0);
    } else {
      // Вечером после 14:00 МСК -> завтра в 10:00 МСК (07:00 UTC)
      return Date.UTC(year, month, day + 1, 10 - 3, 0, 0);
    }
  }

  function getDripSlotLabel(completedAt) {
    if (!completedAt) return 'по расписанию';
    const dt = new Date(completedAt);
    if (isNaN(dt.getTime())) return 'по расписанию';
    const mskHours = (new Date(dt.getTime() + 3 * 3600 * 1000)).getUTCHours();
    if (mskHours < 5) return 'сегодня в 10:00 МСК';
    if (mskHours < 14) return 'сегодня в 19:00 МСК';
    return 'завтра в 10:00 МСК';
  }

  window.getNextDripSlotTimestamp = getNextDripSlotTimestamp;
  window.getNextMorning10MskTimestamp = getNextDripSlotTimestamp;
  window.getDripSlotLabel = getDripSlotLabel;

  // Получить ID для реферальной ссылки